import { observable, toJS } from 'mobx';

export default class AssetPreviewModel {
    @observable assetId = null;
    @observable locationId = null;
    @observable url = null;
    @observable key = null;
    @observable size = null;
    @observable dmrn = null;
    @observable profileKey = null;
    @observable width = null;
    @observable height = null;
    @observable durationMs = null;

    constructor(assetId, locationId, url, key, size, dmrn, profileKey, width, height, durationMs) {
        this.assetId = assetId;
        this.locationId = locationId;
        this.url = url;
        this.key = key;
        this.size = size;
        this.dmrn = dmrn;
        this.profileKey = profileKey;
        this.width = width;
        this.height = height;
        this.durationMs = durationMs;
    }

    toJS() {
        toJS(this);
    }

    static fromJS(auth, object) {
        return new AssetPreviewModel(
            object.asset_id, object.location_id, object.url, object.key, object.size,
            object.dmrn, object.profile_key, object.width, object.height, object.duration_ms,
        );
    }
}
